"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[701],{

/***/ 70701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ faqs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var atoms_caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/prose/index.ts + 1 modules
var prose = __webpack_require__(60864);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
;// CONCATENATED MODULE: ./components/atoms/faqs-element/FaqsElement.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-heading--h5 flex w-full cursor-pointer flex-row items-center justify-between gap-4 border-b transition-all duration-200 hover:border-transparent hover:text-primary-600\n        ",
        "\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        overflow-hidden transition-[max-height] duration-200\n        ",
        "\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            font-thin transition-opacity duration-200\n            ",
        "\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
/**
 * FaqsElement
 */ var FaqsElement = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _selected = param.selected, selected = _selected === void 0 ? false : _selected, title = param.title, children = param.children, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, onClick = param.onClick, link = param.link;
    var ref = (0,react.useState)(defaultOpen), open = ref[0], setOpen = ref[1];
    var realState = onClick ? selected : open;
    var toggle = function() {
        setOpen(!open);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), realState ? "h-auto" : "h-fit", VARIANT_MAPS[variant], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: onClick !== null && onClick !== void 0 ? onClick : toggle,
                className: (0,es/* oneLine */.f9)(_templateObject1(), realState ? "font-bold text-primary-600" : "text-primary-400"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        src: realState ? "DropdowMinus" : "DropdowPlus",
                        width: 20,
                        className: "flex-shrink-0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(_templateObject2(), realState ? "mt-4 max-h-[2000px]" : "max-h-0"),
                children: [
                    typeof children === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                        as: "div",
                        html: children,
                        className: (0,es/* oneLine */.f9)(_templateObject3(), realState ? "opacity-100" : "opacity-0")
                    }) : children,
                    (link === null || link === void 0 ? void 0 : link.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link === null || link === void 0 ? void 0 : link.src,
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            className: "mt-4",
                            arrow: true,
                            variant: link === null || link === void 0 ? void 0 : link.variant,
                            children: link.label
                        })
                    })
                ]
            })
        ]
    });
};
FaqsElement.displayName = "FaqsElement";

;// CONCATENATED MODULE: ./components/atoms/faqs-element/index.ts

/* harmony default export */ var faqs_element = (FaqsElement);

// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/grid/index.ts + 2 modules
var grid = __webpack_require__(81246);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/molecules/faqs-grid/FaqsGrid.tsx





/**
 * FaqsGrid
 */ var FaqsGrid = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, variant = param.variant, children = param.children, columns = param.columns, defaultOpen = param.defaultOpen;
    var ref = (0,react.useState)(-1), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var selectedIndexHandler = function(index) {
        if (selectedIndex === index) {
            setSelectedIndex(-1);
        } else {
            setSelectedIndex(index);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
        xs: 1,
        md: columns,
        lg: columns,
        className: "".concat(className, " !gap-5"),
        children: (0,utils/* toArray */.qo)(children).map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({
                    variant: variant
                }, child.props, defaultOpen ? {
                    defaultOpen: true
                } : {
                    onClick: function() {
                        return selectedIndexHandler(index);
                    },
                    selected: index === selectedIndex
                }))
            }, index);
        })
    });
};
FaqsGrid.displayName = "FaqsGrid";

;// CONCATENATED MODULE: ./components/molecules/faqs-grid/index.ts

/* harmony default export */ var faqs_grid = (FaqsGrid);

;// CONCATENATED MODULE: ./components/organisms/faqs/Faqs.tsx










var PopUpBookingLavanda = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(9501), __webpack_require__.e(735)]).then(__webpack_require__.bind(__webpack_require__, 80735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80735)
            ];
        }
    },
    ssr: false
});
/**
 * Faqs
 */ var Faqs = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, caption = _param.caption, title = _param.title, link = _param.link, imageDesk = _param.imageDesk, faqsProps = _param.faqsProps, columns = _param.columns, variant = _param.variant, cutLevel = _param.cutLevel, cutLevelMobile = _param.cutLevelMobile, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    imageMobile = _param.imageMobile, hascard = _param.hascard, sidecard = _param.sidecard, faqsOpened = _param.faqsOpened, _imageAlign = _param.imageAlign, imageAlign = _imageAlign === void 0 ? "left" : _imageAlign, showCaption = _param.showCaption, config = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "caption",
        "title",
        "link",
        "imageDesk",
        "faqsProps",
        "columns",
        "variant",
        "cutLevel",
        "cutLevelMobile",
        "imageMobile",
        "hascard",
        "sidecard",
        "faqsOpened",
        "imageAlign",
        "showCaption"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(false), formOpen = ref8[0], setFormOpen = ref8[1];
    var popUpToggle = function() {
        setFormOpen(!formOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            sidecard && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpBookingLavanda, {
                apartmentsByBuilding: sidecard.accommodationSelect,
                buildings: sidecard.buildingSelect,
                show: formOpen,
                defaultApartment: sidecard.defaultApartment,
                defaultBuilding: sidecard.defaultBuilding,
                onClose: popUpToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                cutLevel: cutLevel === null ? 50 : cutLevel,
                cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel,
                className: "flex flex-col gap-20 md:flex-row md:gap-32 ".concat(className)
            }, config), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: imageDesk && imageAlign === "left" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden min-w-fit md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imageDesk,
                                height: 610,
                                width: 370,
                                objectFit: "cover",
                                alt: "Imagen de las faqs"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col gap-7 md:gap-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    showCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                                        className: "mb-4",
                                        variant: variant,
                                        children: caption
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-heading text-heading-mobile--h3 text-primary-400 sm:text-heading--h3",
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faqs_grid, {
                                defaultOpen: faqsOpened,
                                variant: variant,
                                columns: columns,
                                children: faqsProps.map(function(child, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(faqs_element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        variant: variant
                                    }, child), {
                                        children: child.children
                                    }), index);
                                })
                            }),
                            (link === null || link === void 0 ? void 0 : link.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: link === null || link === void 0 ? void 0 : link.src,
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                        variant: variant,
                                        arrow: true,
                                        children: link === null || link === void 0 ? void 0 : link.label
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: imageDesk && imageAlign === "right" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden min-w-fit md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imageDesk,
                                height: 610,
                                width: 370,
                                objectFit: "cover",
                                alt: "Imagen de las faqs"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: hascard && sidecard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "h-full w-full overflow-hidden rounded-md md:max-w-[450px]",
                            children: [
                                sidecard.imagen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative h-52 md:h-96",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: sidecard.imagen.sourceUrl,
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: "Imagen de las faqs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-6 bg-surface-10 p-6 text-text-alternative md:py-9",
                                    children: [
                                        sidecard.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                                            variant: "alternative",
                                            children: sidecard.caption
                                        }),
                                        sidecard.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-heading text-heading--h3",
                                            children: sidecard.title
                                        }),
                                        sidecard.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-body text-body--primary",
                                            children: sidecard.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-row flex-wrap items-center gap-5",
                                            children: [
                                                ((ref = sidecard.button) === null || ref === void 0 ? void 0 : ref.src) && ((ref1 = sidecard.button) === null || ref1 === void 0 ? void 0 : ref1.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (ref2 = sidecard.button) === null || ref2 === void 0 ? void 0 : ref2.src,
                                                    passHref: true,
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                        variant: (ref3 = sidecard.button) === null || ref3 === void 0 ? void 0 : ref3.variant,
                                                        as: "a",
                                                        size: "small",
                                                        children: (ref4 = sidecard.button) === null || ref4 === void 0 ? void 0 : ref4.label
                                                    })
                                                }),
                                                ((ref5 = sidecard.link) === null || ref5 === void 0 ? void 0 : ref5.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                    onClick: popUpToggle,
                                                    as: "button",
                                                    variant: (ref6 = sidecard.link) === null || ref6 === void 0 ? void 0 : ref6.variant,
                                                    arrow: true,
                                                    children: (ref7 = sidecard.link) === null || ref7 === void 0 ? void 0 : ref7.label
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }))
        ]
    });
};
Faqs.displayName = "Faqs";

;// CONCATENATED MODULE: ./components/organisms/faqs/index.ts

/* harmony default export */ var faqs = (Faqs);


/***/ })

}]);